import {
    getBrowserName,
    getOperatingSystemName,
    Labels,
} from '@superbet-group/web.observability.sdk-core';
import { currentSite } from '../../app/utils/domainHelpers';
import { getConfig } from '@superbet-group/web.lib.config';

const defaultPlayerVerificationLabels: Labels = {
    browser_name: getBrowserName(),
    os_name: getOperatingSystemName(),
    site: currentSite,
    country: getConfig().countrySpecific.country,
    platform: 'web',
};

export const getPlayerVerificationLabels = (labels: Labels): Labels => {
    return {
        ...defaultPlayerVerificationLabels,
        ...labels,
    };
};
